module.exports = __webpack_public_path__ + "static/media/fly0089.7c806578.webp";